import Constants from '@/Constants';
import Item from '@/models/Item';
import { ApplicationState } from '@/store';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ConfirmDialog from '../ConfirmDialog';
import './styles.scss';

interface Props {
    content: Item;
    startLesson: () => void;
    finishLesson: () => void;
}

const DocumentPlayer: React.FC<Props> = ({ content, startLesson, finishLesson }) => {
    const strings = useSelector((state: ApplicationState) => state.locale.data);

    const [path, setPath] = useState<string>(content.path);
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);

    const downloadDocumentAndFinish = useCallback((): void => {
        setShowConfirmDialog(false);
        window.open(path, '_blank');
        finishLesson();
    }, [path]);

    const loadPath = (): void => {
        if (process.env.NODE_ENV === 'development' && content.path?.startsWith('/static')) {
            setPath(window.location.origin.split(':3000')[0] + content.path);
        }
    };

    useEffect(() => {
        startLesson();
        loadPath();
    }, []);

    return (
        <div className="document-player-container">
            <div className="box-link" onClick={() => setShowConfirmDialog(true)}>
                <div className="box-link__cover">
                    {content.mainImage && <img alt="" className="box-link__cover-thumb" src={content.mainImage} />}
                    <div className="box-link__cover-overlay"></div>
                    <div className="box-link__cover-icon">
                        <span className="material-icons-outlined">{Constants.icons.FILE_COPY}</span>
                    </div>
                </div>
            </div>

            <ConfirmDialog
                content={strings.CONFIRM_DOCUMENT_DOWNLOAD}
                leftButtonTitle={strings.NO}
                leftClick={() => setShowConfirmDialog(false)}
                rightButtonTitle={strings.YES}
                rightClick={downloadDocumentAndFinish}
                show={showConfirmDialog}
                title={strings.ATTENTION}
            />
        </div>
    );
};

export default memo(DocumentPlayer);
